import { Banner, Text } from '@dixa/lib-shared-habla';

import { appActions } from 'app/app.actions';
import { useAppDispatch } from 'utils/redux/useAppDispatch';

import { isWebHidSupportedInBrowser } from '../../../../utils/isWebHidSupportedInBrowser';

export const WebHIDBanner = (): JSX.Element => {
  const dispatch = useAppDispatch();

  const showFeedbackForm = () =>
    dispatch(
      appActions.showModal({
        modal: {
          type: 'app:feedbackForm',
          arg: {
            title: 'Jabra Experimental Browser Support Feedback',
            team: 'core',
          },
        },
      }),
    );

  if (isWebHidSupportedInBrowser()) {
    return (
      <Banner
        variant="announcement"
        headline="Experimental browser support"
        description={
          <Text.Paragraph>
            Jabra in the browser is an experimental feature. If you are
            experiencing issues please{' '}
            <Text.ExternalLink
              style={{ textDecoration: 'underline' }}
              href="#"
              onClick={() => showFeedbackForm()}
            >
              let us know what went wrong
            </Text.ExternalLink>
            , and use the{' '}
            <Text.ExternalLink
              style={{ textDecoration: 'underline' }}
              href="https://www.dixa.com/download/"
              target="blank"
            >
              Dixa desktop app
            </Text.ExternalLink>{' '}
            with improved stability.
          </Text.Paragraph>
        }
      />
    );
  }

  return (
    <Banner
      variant="warning"
      headline="Browser is not supported"
      description={
        <Text.Paragraph>
          Jabra is currently supported in{' '}
          <a
            href="https://www.google.com/chrome/"
            style={{ textDecoration: 'underline' }}
            target="blank"
          >
            Google Chrome
          </a>{' '}
          and{' '}
          <a
            href="https://www.microsoft.com/en-us/edge"
            style={{ textDecoration: 'underline' }}
            target="blank"
          >
            Microsoft Edge
          </a>{' '}
          browsers and{' '}
          <a
            style={{ textDecoration: 'underline' }}
            href="https://www.dixa.com/download/"
            target="blank"
          >
            Dixa desktop app
          </a>
          .
        </Text.Paragraph>
      }
    />
  );
};
